import React from "react";

const HorizontalSeparator: React.FC = () => {
    return <div className="horizontal-separator" />;
};

export default HorizontalSeparator;
